import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { ToastrOptions } from '../Models/Enumeradores/toastr.options';

@Injectable()
export class ApplicationErrorHandler extends ErrorHandler {

    constructor(private injector: Injector, private zone: NgZone) {
        super();
    }

    handleError(errorResponse: HttpErrorResponse | any) {
        if (errorResponse instanceof HttpErrorResponse) {
            const toastrService = this.injector.get(ToastrService);

            this.zone.run(() => {
                switch (errorResponse.status) {
                    case 0:
                        toastrService.error('Falha de comunicação com o servidor', 'Falha de comunicação', ToastrOptions);
                        break;
                    case 400:
                        toastrService.error('Requisição inválida', 'Erro na Requisição', ToastrOptions);
                        break;
                    case 401:
                        toastrService.error('Credenciais inválidas para a requisição', 'Falha de autenticação', ToastrOptions);
                        break;
                    case 403:
                        toastrService.error('Requisição não autorizada', 'Acesso não autorizado', ToastrOptions);
                        break;
                    case 404:
                        toastrService.error('Recurso solicitado não foi encontrado', 'Recurso não encontrado', ToastrOptions);
                        break;
                    case 500:
                        toastrService.error('Erro no servidor ao processar requisição', 'Erro no processamento', ToastrOptions);
                        break;
                }
            });
        }

        super.handleError(errorResponse);
    }
}
